export default Object.freeze({
  NEW: 'NEW',
  ON_OFFER: 'ON_OFFER',
  OOS: 'OOS',
  FAVOURITE: 'FAVOURITE',
  ONE_CLICK: 'ONE_CLICK',
  EDLP: 'EDLP',
});
